import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../contexts/ApiContext';
import { queryKeys } from '../lib/queryClient';
import type { CaseResponse } from '../services/generated/Api';

export function useCasesQuery() {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: queryKeys.cases,
    queryFn: async () => {
      const cases = await apiClient.api.caseControllerGetCases();
      // Filter only active cases
      return (cases || []).filter((c: CaseResponse) => c.isActive);
    },
  });
}

export function useUniversalCasesQuery() {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: [...queryKeys.cases, 'universal'],
    queryFn: async () => {
      const cases = await apiClient.api.caseControllerGetUniversalCases();
      return cases || [];
    },
  });
}

export function useCaseDetails(caseId: string, enabled = true) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: queryKeys.caseDetails(caseId),
    queryFn: () => apiClient.api.caseControllerGetCaseDetails(caseId),
    enabled: enabled && !!caseId,
    staleTime: 5 * 60 * 1000, // 5 минут - предметы кейса не меняются часто
    gcTime: 10 * 60 * 1000,
  });
}
